import { isArray, isEqualWith, isObject } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'
import { areNumericallyEqual } from 'util/number'
import { deepOmitBy } from 'util/object'

export function isDirty<FormModel>(initialValue: FormModel, currentValue: FormModel, ignoredFields: string[]): boolean {
  let dirty = false
  if (isArray(initialValue) && isArray(currentValue)) {
    dirty = isListDirty(initialValue, currentValue, ignoredFields)
  } else {
    dirty = isDeepDirty(initialValue, currentValue, ignoredFields)
  }
  return dirty
}

/**
 * Foi necessario adicionar o deepOmitBy para remover os campos undefined e null porque a funcao isEqualWith
 * soh traz as keys em comum para o customizer, ai nao estava trazendo keys que eram ignoradas e considerando como dirty
 * Issue: 24398
 */
function isDeepDirty<FormModel>(initialFormValue: FormModel, currentFormValue: FormModel, ignoredFields: string[]) {
  const initialValuesWithoutUndefinedNull = isObject(initialFormValue)
    ? deepOmitBy(initialFormValue, isUndefinedOrNull)
    : initialFormValue
  const currentValuesWithoutUndefinedNull = isObject(currentFormValue)
    ? deepOmitBy(currentFormValue, isUndefinedOrNull)
    : currentFormValue

  return !isEqualWith(
    initialValuesWithoutUndefinedNull,
    currentValuesWithoutUndefinedNull,
    (_initialFieldValue, _currentFieldValue, key) => {
      const isFieldEqual =
        ignoredFields.some((ignoredField) => ignoredField === key) ||
        areNumericallyEqual(_initialFieldValue, _currentFieldValue)
      return isFieldEqual ? true : undefined
    }
  )
}

function isListDirty<FormModel>(initialFormValue: FormModel[], currentFormValue: FormModel[], ignoredFields: string[]) {
  if (isUndefinedOrNull(initialFormValue) && isUndefinedOrNull(currentFormValue)) {
    return false
  }

  if (initialFormValue.length !== currentFormValue.length) {
    return true
  }

  return currentFormValue.some((currentValue, index) =>
    isDeepDirty(initialFormValue[index], currentValue, ignoredFields)
  )
}
